import ribben1 from "../assets/Group-4.png";
import ribben2 from "../assets/ribbon-horizontal-banner-design-svgrepo-com 2.png";
import ribben3 from "../assets/ribbon-horizontal-banner-design-svgrepo-com 4.png";
import ribben4 from "../assets/ribbon-horizontal-banner-design-svgrepo-com 4.svg";
import ribben5 from "../assets/ribbon-horizontal-banner-design-svgrepo-com 5.svg";
import style from "../components/AffordableGateways.module.css";

import './AffordableGateways.module.css';
import { useNavigate } from "react-router-dom";

const AffordableGateways = () => {
  const navigate = useNavigate();

  // Function to handle budget navigation with the budget value
  const HandleBudgets = (budget) => {
    // Navigate to the tour search page with the budget as a query parameter
    navigate(`/tours?budget=${budget}`);
  };

  return (
    <>
      <div className="budgettourcarousel">
        <div className="container mb-5 text-start">
        <h3 style={{ color: "#321E5D",fontWeight:"800" }}>Affordable Gateways <span style={{ color: "#680099" }}>For All Budgets</span></h3>
        <p className="" style={{fontSize:"14px"}}>Favorites Destination Based On Budget</p>
        </div>
        <div className="position-relative mb-5" style={{ minHeight: "350px", background: "rgba(245, 235, 255, 1)" }}>
          <div className="container d-flex flex-row justify-content-center gap-5" style={{ paddingTop: "30px" ,overflowX:'auto',overflowY:'hidden'}}>
            <div className={`rounded-3 btn bg-white   mt-5 ${style.HoverEffect}`} style={{ height: "200px", width: "160px" }} onClick={() => HandleBudgets(50000)}>
              <div className="text-center ">
                <div className="d-flex flex-column text-decoration-none mt-2 mb-5">
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px",color: "rgba(60, 24, 136, 1)"}}>Below</span>
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px"}}>₹50,000</span>
                </div>
                <img src={ribben1} alt="block1" className="img-fluid" width={130} />
              </div>
            </div>
            <div className={`rounded-3 btn bg-white   mt-5   ${style.HoverEffect}`} style={{ height: "200px", width: "160px" }} onClick={() => HandleBudgets(60000)}>
              <div className="text-center ">
                <div className="d-flex flex-column text-decoration-none mt-2">
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px",color: "rgba(51, 152, 49, 1)"}}>Below</span>
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px"}}>₹60,000</span>
                </div>
                <img src={ribben2} alt="block1" className={`img-fluid ${style.Filter}`} width={130} />
              </div>
            </div>
            <div className={`rounded-3 btn bg-white   mt-5   ${style.HoverEffect}`} style={{ height: "200px", width: "160px" }} onClick={() => HandleBudgets(80000)}>
              <div className="text-center ">
                <div className="d-flex flex-column text-decoration-none mt-2">
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px",color: "rgba(255, 113, 33, 1)"}}>Below</span>
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px"}}>₹80,000</span>
                </div>
                <img src={ribben3} alt="block1" className={`img-fluid ${style.Filter}`} width={130} />
              </div>
            </div>
            <div className={`rounded-3 btn bg-white   mt-5  ${style.HoverEffect}`} style={{ height: "200px", width: "160px" }} onClick={() => HandleBudgets(90000)}>
              <div className="text-center ">
                <div className="d-flex flex-column text-decoration-none mt-2">
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px",color: "rgba(0, 111, 213, 1)"}}>Below</span>
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px"}}>₹90,000</span>
                </div>
                <img src={ribben4} alt="block1" className={`img-fluid ${style.Filter}`} width={130} />
              </div>
            </div>
            <div className={`rounded-3 btn bg-white   mt-5 ${style.HoverEffect}`} style={{ height: "200px", width: "160px" }} onClick={() => HandleBudgets(100000)}>
              <div className="text-center ">
                <div className="d-flex flex-column text-decoration-none mt-2">
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px",color:"rgba(84, 6, 111, 1)"}}>Below</span>
                  <span className="fw-bold text-decoration-none" style={{fontSize:"25px"}}>₹1,00,000</span>
                </div>
                <img src={ribben5} alt="block1" className={`img-fluid ${style.Filter}`} width={130} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AffordableGateways;
